const { BaseCollection } = require('./_base.collection')

/**
 * @typedef StripeSubscriptionModel
 * @property {string} id
 */

/**
 * @extends {BaseCollection<StripeSubscriptionModel>}
 */
class StripeSubscriptionCollection extends BaseCollection {
  constructor() {
    super('STRIPE_SUBSCRIPTIONS')
  }
}

const stripeSubscriptionCollection = new StripeSubscriptionCollection()

module.exports = {
  stripeSubscriptionCollection
}
